import globals from '~/globals';
import FormViewer from 'Components/FormViewer';
import React from 'react';
import { useSelector } from 'react-redux';

const Component = () => {
    const template = useSelector(state => state.templates.models[state.drawerView.entityId]);

    return (
        <FormViewer label="Template Details">
            <a href={`${globals.apiUrl}/installation_templates/${template.id}/report`} rel="noreferrer" target="_blank">Download File</a>
            <br/>
            <pre>{JSON.stringify(template.data, null, 2)}</pre>
        </FormViewer>
    );
};

export default Component;
